angular.module('bgDirectives', [])
  .directive('bgSplitter', function ($rootScope, $timeout) {
    return {
      restrict  : 'E',
      replace   : true,
      transclude: true,
      scope     : {
        pos        : '=',
        orientation: '@'
      },
      template  : '<div class="maximize split-panes {{orientation}}" ng-transclude></div>',
      controller: function ($scope) {
        $scope.panes = [];
        this.addPane = function (pane) {
          if ($scope.panes.length > 1)
            throw 'splitters can only have two panes';
          $scope.panes.push(pane);
          return $scope.panes.length;
        };
        $scope.showDimensions = true;
//         $scope.showPane2 = false;
      },
      link      : function (scope, element) {
        let handler = angular.element('<div class="split-handler"></div>');
        let pane1 = scope.panes[0];
        let pane2 = scope.panes[1];
        let vertical = scope.orientation == 'vertical';
        let pane1Min = pane1.minSize || 0;
        let pane2Min = pane2.minSize || 0;
        let drag = false;
        pane1.elem.after(handler);

        if (vertical) {
          let oldHeight;
          let setSplitter = function (pos, limit) {
            let height = oldHeight = element.height();
            let pane1Height = pos;
            if (limit) {
              if (pos < pane1Min) pane1Height = pane1Min;
              if (pos > height - pane2Min) pane1Height = height - pane2Min;
            }
            pane1.elem.css('height', pane1Height + 'px');
            handler.css('top', pane1Height + 'px');
            const heightHandler = handler.height();
            pane2.elem.css('top', (pane1Height + heightHandler) + 'px');
            pane2.elem.css('height', (height - pane1Height - heightHandler) + 'px');
            $rootScope.$broadcast('splitterChanged');
          };
          let setUp = function () {
            if (!pane1.elem.height()) {
              return;
            }
            let newHeight = element.height();
            let ratio = oldHeight && newHeight ? newHeight / oldHeight : 1;
            let pos = pane1.elem.height() * ratio;
            setSplitter(pos);
          };

          scope.$on('resize', setUp);

          let pane1Initial = Math.round($('#facts-container').height() / 5 * 4);

          element.bind('mousemove', function (ev) {
            if (!drag) return;
            let bounds = element[0].getBoundingClientRect();
            let pos = ev.clientY - bounds.top;
            let maxPos = element.height() - handler.height();
            if (pos > maxPos) {
              pos = maxPos;
            }
            setSplitter(pos, true);
          });
          let togglePane2 = function (setstate) {
            let oldState = scope.showPane2;
            let newState = setstate != undefined ? setstate : !scope.showPane2;
            if (oldState == newState) return;
            scope.showPane2 = newState;
            let state = scope.showPane2;
            if (state == false) {
              scope.pane1ElemHeight = pane1.elem.height();
              setSplitter(element.height() - handler.height());
            } else {
              if (scope.pane1ElemHeight) {
                setSplitter(scope.pane1ElemHeight);
              } else {
                setSplitter(pane1Initial);
              }
            }
          };
          handler.bind('dblclick', function () {
            togglePane2();
          });
          handler.bind('click', function () {
            if (pane1.elem.height() == element.height() - handler.height()) {
              togglePane2();
            }
          });
          scope.$on('showPane2', function () {
            scope.pane1ElemHeight = $(window).height() / 2;
            togglePane2(true);
          });
          scope.$on('hidePane2', function () {
            togglePane2(false);
          });
          scope.$watch('pos', function (pos) {
            if (pos) setSplitter(pos, 0);
          });
//             togglePane2(false);
        } else {
          // let lastPos;
          let setSplitter = function (pos, limit) {
            // if (pos === lastPos) return;
            // lastPos = pos;
            let bounds = element[0].getBoundingClientRect();
            let width = bounds.right - bounds.left;
            let pane1Width = pos;
            if (limit) {
              if (pos < pane1Min) pane1Width = pane1Min;
              if (pos > width - pane2Min) pane1Width = width - pane2Min;
            }
            pane1.elem.css('width', pane1Width + 'px');
            handler.css('left', pane1Width + 'px');
            pane2.elem.css('left', pane1Width + handler.width() + 'px');
            const pane2Width = width - pane1Width - handler.width();
            pane2.elem.css('width', pane2Width + 'px');
            // console.log('Setting horizontal splitter..', pane1Width, pane2Width);
            $rootScope.$broadcast('splitterChanged');
          };
          element.bind('mousemove', function (ev) {
            if (!drag) return;
            let bounds = element[0].getBoundingClientRect();
            let pos = ev.clientX - bounds.left;
            setSplitter(pos, true);
          });
          let togglePane1 = function (setState) {
            let oldState = scope.showDimensions;
            let newState = setState != undefined ? setState : !scope.showDimensions;
            if (oldState == newState) return;
            scope.showDimensions = newState;
            let state = scope.showDimensions;
            if (state == false) {
              scope.pane1ElemWidth = pane1.elem.width();
              setSplitter(0);
            } else {
              if (scope.pane1ElemWidth) {
                setSplitter(scope.pane1ElemWidth);
              }
            }
            window.isPaneOpen = state;
          };

          handler.bind('click', function (ev) {
            if (pane1.elem.width() == 0) {
              togglePane1(true);
            }
            ev.preventDefault();
          });
          handler.bind('mousemove', function (ev) {
            if (pane1.elem.width() == 0) {
              //togglePane1(true);
              window.isPaneOpen = true;
            }
            ev.preventDefault();
          });
          angular.element(document).on('showDimensions', function (src, state, pos) {
            togglePane1(state);
            if (pos != undefined) {
              setSplitter(pos, 0);
            }
          });
          scope.$watch('pos', function (pos) {
            if (pos) setSplitter(pos, 0);
          });
          scope.$on('resize', function () {
            setSplitter(pane1.elem.width());
          });
        }

        handler.bind('mousedown', function (ev) {
          // Fix for frame
          $('.frameOverlay').css('z-index', 2);
          drag = true;
          ev.preventDefault();
        });

        angular.element(document).bind('mouseup', function () {
          // Fix for frame
          $('.frameOverlay').css('z-index', -1);
          drag = false;
        });

      }
    };
  })

  .directive('bgPane', function () {
    return {
      restrict  : 'E',
      require   : '^bgSplitter',
      replace   : true,
      transclude: true,
      scope     : {
        minSize: '='
      },
      template  : '<div class="split-pane{{index}}" ng-transclude></div>',
      link      : function (scope, element, attrs, bgSplitterCtrl) {
        scope.elem = element;
        scope.index = bgSplitterCtrl.addPane(scope);
      }
    };
  });



// WEBPACK FOOTER //
// ./src/lib/splitter.js